import React, { PropsWithChildren } from 'react';
import { useIsClientLocked } from './useIsClientLocked.hook';
import { AlertOverlay } from '../Overlay.component';

type ClientLockedOverlayProps = PropsWithChildren<{
  message?: string,
}>

export const ClientIsLockedOverlay: React.FC<ClientLockedOverlayProps>
  = ({ children, message }: ClientLockedOverlayProps) => {
    const isClientLocked = useIsClientLocked();

    return (
      <AlertOverlay
        message={message}
        show={isClientLocked}
        type="alert-warning"
      >
        {children}
      </AlertOverlay>
    );
  };
